<template>
  <div :id="radio == 1 ? 'login_corentercomBg' : 'login_bnd'">
    <div v-title :data-title="$t('message.about.title')"></div>
    <div class="language" v-if="$store.state.isProject != 'towway'">
      <!-- <span
        :class="$store.state.language == 'zh' ? 'on' : ''"
        @click="setLanguage('zh')"
        >中文</span
      >
      <span
        :class="$store.state.language == 'en' ? 'on' : ''"
        @click="setLanguage('en')"
        >English</span
      >
      <span
        :class="$store.state.language == 'tn' ? 'on' : ''"
        @click="setLanguage('tn')"
        >ภาษาไทย</span
      > -->
      <el-dropdown @command="setLanguage">
        <span class="el-dropdown-link">
          {{ $store.state.language | languageName(that)
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in languageArr"
            :key="item.key"
            :command="item.key"
            :class="$store.state.language == item.key ? 'lang_active' : ''"
            >{{ item.name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div
      class="right"
      :class="
        $store.state.isProject != 'xinpoc' &&
        $store.state.isProject != 'ZENTRIX'
          ? 'right_auto'
          : ''
      "
    >
      <div style="width: 100%; text-align: center">
        <img
          class="img"
          :style="{ height: logoImgHeight() }"
          :src="tabArray[radio].url"
          alt=""
        />
      </div>
      <div
        style="
          font-size: 22px;
          color: #ffffff;
          margin: 30px auto 50px;
          text-align: center;
        "
        v-if="$t('message.message.voice_title')"
      >
        {{ $t("message.message.voice_title") }}
      </div>
      <div class="box" v-if="$store.state.isProject != 'ZENTRIX'">
        <div class="math">
          <div class="top">
            {{ $t("message.about.title") }}
            <!-- <el-radio-group class="top" v-model="radio" @change="changeValue()">
              <el-radio :class="['el_radio', item.css]" v-for="item in tabArray" :key="item.id" v-model="item.show"
                :text-color="item.color" :fill="item.color" :label="item.id">
                <img class="img" :style="item.style" :src="item.indexUrl" alt="" />
              </el-radio>
            </el-radio-group> -->
          </div>
          <div class="el_form">
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
            >
              <el-form-item prop="username">
                <el-input
                  type="text"
                  :placeholder="$t('message.login.account')"
                  @input="bindInput"
                  maxlength="15"
                  v-model.trim="ruleForm.username"
                >
                </el-input>
                <!-- autocomplete="on" -->
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="ruleForm.password"
                  autocomplete="new-password"
                  :placeholder="$t('message.login.password')"
                >
                </el-input>
                <!-- autocomplete="on" -->
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="submitForm('ruleForm')"
                  v-preventReClick
                  class="login-submit"
                  >{{ $t("message.login.Login") }}</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div class="bottom">
            <div>
              {{ $t("message.login.rememberme") }}？
              <el-switch
                v-model="checked"
                :active-color="$store.state.colorKey['--main-login-page-color']"
                inactive-color="#838383"
              >
              </el-switch>
            </div>
            <a class="el_form_a" :href="xzURL">{{
              $t("message.login.installationServices")
            }}</a>
          </div>
        </div>
      </div>
      <div class="zd_login" v-else>
        <div class="math">
          <div class="top">
            <!-- {{ $t("message.about.title") }} -->
            Global Communication Dispatcher
          </div>
          <div class="el_form">
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
            >
              <el-form-item prop="username">
                <el-input
                  type="text"
                  :placeholder="$t('message.login.account')"
                  @input="bindInput"
                  maxlength="15"
                  v-model.trim="ruleForm.username"
                >
                  <template slot="prepend">
                    <img
                      class="zd_login_img"
                      src="../assets/login/login_at.png"
                      alt=""
                    />
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="ruleForm.password"
                  autocomplete="new-password"
                  :placeholder="$t('message.login.password')"
                >
                  <template slot="prepend">
                    <img
                      class="zd_login_img"
                      src="../assets/login/login_pass.png"
                      alt=""
                    />
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="submitForm('ruleForm')"
                  v-preventReClick
                  class="login-submit"
                  >{{ $t("message.login.Login") }}</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div class="bottom">
            <div>
              {{ $t("message.login.rememberme") }}？
              <el-switch
                v-model="checked"
                :active-color="$store.state.colorKey['--main-color']"
                inactive-color="#838383"
              >
              </el-switch>
            </div>
            <a class="el_form_a" :href="xzURL">{{
              $t("message.login.installationServices")
            }}</a>
          </div>
        </div>
      </div>

      <div class="development" v-if="isDevelopmentObj[$store.state.isProject]">
        <img
          v-if="$store.state.isProject == 'wanlian'"
          src="@/assets/login/logo.png"
          style="width: 132px; height: 132px"
          alt=""
        />
        <div v-if="isCompanyObj[$store.state.isProject]" v-html="eachColor()">
          {{ $t("message.about.conpanyname") }}
        </div>
        <div
          :style="
            $store.state.isProject == 'ZENTRIX'
              ? 'margin-top: 30px'
              : 'margin-top: 10px'
          "
        >
          {{ $t("message.about.version") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script></script>
<script>
import { Login } from "@/administration/login.js";
import regfunc from "@/method/form/regfunc.js";
import EventBus from "../eventBus/eventBus.js";
import beasconfig from "@/api/beasconfig.js";
// var ws;
export default {
  data() {
    var username = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("message.message.loginAccountTips")));
      }
      if (!regfunc.rNum.test(value)) {
        callback(new Error(this.$t("message.message.accountNumbers")));
      } else {
        callback();
      }
    };
    var password = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("message.message.loginPasswordTips")));
      } else {
        callback();
      }
    };
    return {
      checked: false,
      ruleForm: {
        //账号密码
        username: "", //账号
        password: "", //密码
      },
      radio: 1, //选择tab的下标
      rules: {
        username: [{ validator: username, trigger: "blur" }],
        password: [{ validator: password, trigger: "blur" }],
      },
      tabArray: [
        {
          id: 0,
          url: require("@/assets/login/bonardDesk.png"),
          indexUrl: require("@/assets/login/bonardptt.png"),
          color: "#ffba17",
          style: "width: 155px;height: 35px;",
          show: false,
          css: "tab1",
        },
        {
          id: 1,
          url: require("@/assets/login/coreintercomDesk.png"),
          indexUrl: require("@/assets/login/coreintercom.png"),
          color: "var(--main-login-page-color)",
          style: "width: 138px;height: 35px;",
          show: false,
          css: "tab2",
        },
      ],
      xzURL: beasconfig.xinextendUrlapi, //安装包路径
      isInstall: false,
      languageArr: [
        {
          key: "en",
          name: "English",
        },
        {
          key: "zh",
          name: "中文（简体）",
        },
        {
          key: "zhTW",
          name: "中文（繁體）",
        },
        {
          key: "epn",
          name: "Español",
        },
        {
          key: "fn",
          name: "Français",
        },
        {
          key: "tn",
          name: "แบบไทย",
        },
        {
          key: "ind",
          name: "Indonesian language",
        },
      ],
      that: this,
      isDevelopmentObj: {
        xinpoc: true,
        chunsheng: true,
        TALK2ME: true,
        wanlian: true,
        EuroNews: true,
        ShangHaotong: true,
        ZENTRIX: true,
      },
      isCompanyObj: {
        xinpoc: true,
        chunsheng: true,
        TALK2ME: true,
        wanlian: true,
        EuroNews: true,
        ShangHaotong: false,
        ZENTRIX: true,
      },
    };
  },
  created() {
    //记住密码判断是否记住密码 记住密码则在一开始就渲染上去
    this.xzURL = `${
      beasconfig.xinextendUrlapi
    }/dispatcher.exe?${Math.random()}`;
    let userNumber = JSON.parse(localStorage.getItem("userNumber"));
    if (userNumber && userNumber.checked) {
      this.ruleForm.username = userNumber.userName;
      this.ruleForm.password = userNumber.password;
      this.checked = true;
    }
    this.$forceUpdate();
    sessionStorage.removeItem("ballId");
    this.$store.state.ballId = 1;
  },
  // beforeUpdate() {
  //   console.log('----beforeUpdate----')
  // },
  mounted() {},
  filters: {
    languageName(val, that) {
      //展示下拉语言名称
      let row = that.languageArr.find((item) => item.key == val);
      let name = row ? row.name : that.languageArr[0].name;
      return name;
    },
  },
  methods: {
    eachColor() {
      let content = this.$t("message.about.conpanyname");
      if (content == undefined) {
        return;
      }
      let searchVal = "";
      let obj = {
        ZENTRIX: "ZENTRIX",
      };

      if (obj[this.$store.state.isProject]) {
        searchVal = obj[this.$store.state.isProject];
      }
      let nt =
        '<span style="color:var(--main-color);">' + searchVal + "</span>";
      return content.replace(searchVal, nt) + "&nbsp;";
    },
    logoImgHeight() {
      //根据不同项目设置logo高度
      let height = {
        HPYJ: "75px",
        yuantong: "109px",
        chunsheng: "45px",
        TALK2ME: "194px",
        quansheng: "153px",
        ZENTRIX: "74px",
      };

      return height[this.$store.state.isProject]
        ? height[this.$store.state.isProject]
        : "73px";
    },
    setLanguage(val) {
      if (this.$store.state.language == val) {
        return;
      }
      localStorage.setItem("languageStorage", val);
      this.$store.state.language = val;
      this.$i18n.locale = val;
      document.title = this.$t("message.about.title");
    },
    bindInput(value) {
      //不能输入
      this.$forceUpdate();
      this.ruleForm.username = value.replace(/[^\d]/g, "");
      this.$store.state.userName = this.ruleForm.username;
      // let reg = /^[0-9]{1,15}$/g;
      // let n = value.search(reg);
      // if (n === -1 && value.length > 1) {
      //   this.ruleForm.username = value.slice(0, n);
      // }
    },
    submitForm(formName) {
      //登录
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this;
          if (_this.$store.state.isLinkSuccess) {
            let data = {
              userName: _this.ruleForm.username.trim(),
              password: _this.ruleForm.password.trim(),
              version: 2.1,
            };
            Login(data)
              .then((res) => {
                if (res.data.code == 200) {
                  console.log(res.data);
                  if (res.data.data.User_Type != 3) {
                    _this.$MessageWarning(
                      _this.$t("message.message.noDispatcher"),
                    );
                  } else if (res.data.data.User_Enable == 1) {
                    //判断是否停用
                    sessionStorage.setItem(
                      "userInfo",
                      JSON.stringify(res.data.data),
                    );
                    sessionStorage.setItem("userNumber", JSON.stringify(data));
                    data.checked = _this.checked;
                    localStorage.setItem("userNumber", JSON.stringify(data));
                    EventBus.$emit("login");
                  } else {
                    _this.$MessageWarning(
                      _this.$t("message.message.accountNotpresent"),
                    );
                  }
                } else if (res.data.code == 4001) {
                  _this.$MessageWarning(
                    _this.$t("message.message.usernamePasswordTips"),
                  );
                } else {
                  _this.$MessageWarning(res.data.msg);
                }
              })
              .catch((error) => {
                // console.log(error); //请求失败返回的数据
                _this.$MessageWarning(
                  _this.$t("message.message.LoginAbnormal"),
                );
              });
          } else {
            _this.$MessageWarning(
              _this.$t("message.message.voiceServiceNotInstalled"),
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changeValue() {
      this.radio = 1;
    },
  },
  beforeRouteEnter(to, from, next) {
    //监听浏览器回退 回退到登录页面就退出登录
    next((vm) => {
      if (from.name != null && from.name != "Login") {
        EventBus.$emit("changePassword");
      }
    });
  },
};
</script>

<style lang="less" scoped>
#login_bnd {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: url(../assets/login/bonardBg.jpg);
  background-size: 100% 100%;
}

#login_corentercomBg {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: url(../assets/login/coreintercomBg.png);
  background-size: 100% 100%;
}

.right {
  margin-left: 60vw;

  .img {
    position: relative;
    z-index: 10;
    // width: 356px;
    height: 73px;
    margin-bottom: 20px;
  }

  .box {
    width: 510px;
    // width: 439px;
    // height: 433px;
    background-color: #ffffff;
    border-radius: 10px;
    border: 1px solid var(--main-login-page-color);

    .math {
      width: 85%;
      margin: auto;
    }

    .el_form {
      margin: 0px 0px;

      .login-submit {
        width: 100%;
        color: #ffffff;
        background-color: var(--main-login-page-color);
        font-size: 20px;
        font-weight: bold;
      }
    }

    .top {
      width: 100%;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-family: "Microsoft YaHei";
      color: var(--main-login-page-color);
      // border-bottom: 1px solid var(--main-login-page-color);

      .el_radio {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    .bottom {
      color: #838383;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 40px 0px;
    }
  }

  .zd_login {
    width: 31.9375rem;
    height: 24.5rem;
    background: url("../assets/login/form_bg.png");
    background-size: 100% 100%;
    margin-top: 4px;

    &_img {
      width: 20px;
      height: 20px;
    }

    .math {
      width: calc(100% - 80px);
      margin: auto;
    }

    .el_form {
      margin: 0px 0px;

      .el-form-item {
        margin-bottom: 22px;
      }

      .el-form-item:nth-child(2) {
        margin-bottom: 23px;
      }

      .el-form-item:last-child {
        margin-bottom: 0px;
      }

      /deep/.el-input {
        width: calc(100% - 1px);
        height: 40px;
        font-size: 16px;
        background-color: #223462;
        border-radius: 8px;
        padding-right: 1px;

        & > input {
          height: 38px;
          line-height: normal;
          border-radius: 0px 8px 8px 0px;
          background-color: #021540;
          border: 1px solid #223462;
          color: #ffffff;
          margin-top: 1px;
          padding: 0px 10px;
        }

        .el-input-group__append,
        .el-input-group__prepend {
          background-color: #103a86;
          border: none;
          border-radius: 8px 0px 0px 8px;
          padding: 0 10px;
        }
      }

      .login-submit {
        width: 100%;
        color: #ffffff;
        // background-color: var(--main-login-page-color);
        background: linear-gradient(180deg, #0663e4 0%, #0437c6 100%);
        font-size: 16px;
        border: none;
      }

      /deep/.el-button {
        height: 44px;
        line-height: 44px;
        text-align: center;
        padding: 0px;
      }
    }

    .top {
      width: 100%;
      padding: 40px 0px;
      // height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 24px;
      // font-weight: bold;
      font-family: "Microsoft YaHei";
      color: var(--main-login-page-color);
      // border-bottom: 1px solid var(--main-login-page-color);

      .el_radio {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    .bottom {
      color: #b2bfe1;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 41px 0px;
    }
  }

  .development {
    width: 100%;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
    margin-top: 30px;
  }

  .el_form_a {
    color: red;
    font-size: 13px;
    letter-spacing: 2px;
    font-weight: bold;
  }
}

.right_auto {
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tab1 {
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border: 1px solid #ffba17;
    border-color: #ffba17;
    background-color: #ffffff;
  }

  /deep/.el-radio__inner {
    border: 1px solid #ffba17;
  }

  /deep/ .el-radio__inner::after {
    width: 6px;
    height: 6px;
    background-color: #ffba17 !important;
  }
}

.tab2 {
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: var(--main-login-page-color);
    background-color: #ffffff;
  }

  /deep/.el-radio__inner {
    border: 1px solid var(--main-login-page-color);
  }

  /deep/ .el-radio__inner::after {
    width: 6px;
    height: 6px;
    background-color: var(--main-login-page-color) !important;
  }
}

.language {
  position: absolute;
  right: 0;
  top: 0;
  padding: 20px 30px;
}

.language span {
  display: inline-block;
  color: #fff;
  cursor: pointer;
  padding: 0 30px;
}

.lang_active {
  color: var(--lang-active);
}
</style>
